/* eslint-disable max-len */
export const requiredValidation = (value, message) => (value.length > 0 ? false : message || '');

export const nameValidation = (value, message) => {
  if (value.length <= 1) return message;
  if (value.replace(/ /g, '').length === 0) return message;

  return /^(?![- ])[A-Za-zёЁА-Яа-я -]{0,60}$/.test(value) ? false : message || '';
};

export const phoneValidation = (value, message) => {
  if (value.length === 0) return false;
  return /[0-9]{10}$/.test(value) && value.charAt(0) === '9' && value.length === 10 ?
      false
    : message || '';
};

export const eMailValidation = (value, message) => {
  if (value.length === 0) return false;
  return (
      /^([A-Za-z0-9_-]+\.)*[A-Za-z0-9_-]+@[A-Za-z0-9_-]+(\.[A-Za-z0-9_-]+)*\.[a-z]{2,6}$/.test(
        value,
      )
    ) ?
      false
    : message || '';
};

export const REG_EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const getIsEmailValid = (email) => REG_EMAIL.test(email);

export const getTelNumberValue = (tel) => tel.replace(/[^\d]/g, '');

export const signDocumentsValidate = (values) => {
  const errors = {};

  if (values.migrationCart) {
    if (!values.migrationCartNumber) {
      errors.migrationCartNumber = 'Укажите номер миграционной карты';
    } else if (values.migrationCartNumber.length > 10 || values.migrationCartNumber.length < 1) {
      errors.migrationCartNumber = 'Не правильно заполненно поле';
    } else if (!values.migrationCartNumber.match(/^[0-9 ]+$/)) {
      errors.migrationCartNumber = 'Не правильный формат данных';
    }
    if (!values.migrationCartSeries) {
      errors.migrationCartSeries = 'Укажите серию миграционной карты';
    } else if (values.migrationCartSeries.length > 10 || values.migrationCartSeries.length < 1) {
      errors.migrationCartSeries = 'Не правильно заполненно поле';
    } else if (!values.migrationCartSeries.match(/^[0-9 ]+$/)) {
      errors.migrationCartSeries = 'Не правильный формат данных';
    }

    if (!values.migrationCartDateFrom) {
      errors.migrationCartDateFrom = 'Укажите дату действия миграционной карты';
    }
    if (!values.migrationCartDateTo) {
      errors.migrationCartDateTo = 'Укажите серию миграционной карты';
    }
  }

  if (values.indexCity) {
    if (values.indexCity.length > 20) {
      errors.indexCity = 'Не правильно заполненно поле';
    } else if (!values.indexCity.match(/^[0-9 ]+$/)) {
      errors.indexCity = 'Не правильный формат данных';
    }
  }
  //   regBuilding,
  return errors;
};
